export default "__VITE_ASSET__BVM4ZNk8__"